<template>
  <v-list-item v-bind="$attrs">
    <v-list-item-avatar v-if="avatar">
      <v-img :src="item.avatar"></v-img>
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title class="body-2" v-text="title"></v-list-item-title>
    </v-list-item-content>

    <v-list-item-icon v-if="icon" @click="$emit('icon-clicked')">
      <v-btn icon small color="black">
        <v-icon
          :small="iconSmall"
          :large="iconLarge"
          :x-large="iconXLarge"
        >{{ icon }}</v-icon>
      </v-btn>
    </v-list-item-icon>
  </v-list-item>
</template>

<script>
export default {
  name: 'ListItem',
  props: {
    avatar: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      required: true,
      default: ''
    },
    icon: {
      type: String,
      default: 'mdi-delete'
    },
    iconSmall: {
      type: Boolean,
      default: false
    },
    iconLarge: {
      type: Boolean,
      default: false
    },
    iconXLarge: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>

</style>